import { FC } from 'react';
import { useIntl } from 'react-intl';

interface NumberStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
}

const NumberStepper: FC<NumberStepperProps> = ({
  value,
  onChange,
  min = 1,
}) => {
  const intl = useIntl();

  return (
    <div className="d-flex align-items-center gap-3">
      <button
        className="btn btn-outline-secondary btn-lg d-flex align-items-center justify-content-center"
        style={{
          width: 64,
          height: 64,
          fontSize: 28,
          borderRadius: 16,
          touchAction: 'manipulation',
        }}
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label={intl.formatMessage({ id: 'picking.decreasePackages' })}
      >
        -
      </button>
      <span
        className="fw-bold text-center"
        style={{ fontSize: 28, minWidth: 48 }}
        aria-live="polite"
      >
        {value}
      </span>
      <button
        className="btn btn-outline-secondary btn-lg d-flex align-items-center justify-content-center"
        style={{
          width: 64,
          height: 64,
          fontSize: 28,
          borderRadius: 16,
          touchAction: 'manipulation',
        }}
        onClick={() => onChange(value + 1)}
        aria-label={intl.formatMessage({ id: 'picking.increasePackages' })}
      >
        +
      </button>
    </div>
  );
};

export { NumberStepper };
